// Simulate touch as hover
// element:hover, element:active { }
document.addEventListener("touchstart", function(){}, true);
